<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let additionalClass: string = '';
	export let chevronLeft: boolean = false;
	export let disabled: boolean = false;
	export let ariaLabel: string = chevronLeft ? $t('aria.previous-month') : $t('aria.next-month');
	export let role: string = 'button';
</script>

<button
	class={classes(
		additionalClass,
		`${chevronLeft ? 'i-sprenger-chevron-left' : 'i-sprenger-chevron-right'} w-6`,
		disabled ? 'text-gray-300 pointer-events-none' : 'text-black cursor-pointer'
	)}
	on:click
	on:keypress
	aria-label={ariaLabel}
	{role}
>
</button>
